import { Container, Typography } from "@material-ui/core";
// import axios from "axios";
import React from "react";
// import { useState } from "react";
// import { useEffect } from "react";

export default function ThankYou() {
	// const [marks, setMarks] = useState(0);
	// useEffect(() => {
	// 	const getData = async () => {
	// 		const token = localStorage.getItem("token");
	// 		axios
	// 			.get(`${process.env.REACT_APP_BACKEND_URL}/attempt/marks`, {
	// 				headers: {
	// 					Authorization: `Bearer ${token}`,
	// 				},
	// 			})
	// 			.then((res) => {
	// 				setMarks(res.data.marks);
	// 			});
	// 	};
	// 	getData();
	// }, []);

	return (
		<Container
			style={{
				display: "flex",
				flexDirection: "column",
				justifyContent: "center",
				height: "80vh",
				textAlign: "center",
			}}
		>
			<img src="/logo.png" className="avatar" alt="Josh Talks" />
			<div
				style={{
					display: "flex",
					flexDirection: "column",
					justifyContent: "space-around",
					minHeight: "260px",
					textAlign: "center",
				}}
			>
				<Typography variant="h4">Thank You</Typography>
				<Typography variant="h6">You have successfully completed your JRT.</Typography>
				<Typography variant="h6">
					You will receive your results and scorecard via email.
				</Typography>
				<Typography variant="h6">All the best!</Typography>
			</div>
		</Container>
	);
}
